import { PROVIDERS, type Provider } from '@latency-globe/shared';
import type { Store } from '../store.ts';
import { clear, el, PROVIDER_LABEL } from './dom.ts';

/** Provider tabs are text, not colour-coded: colour is spoken for by the map (SPEC §9.2). */
export function mountTabs(root: HTMLElement, store: Store): void {
  const render = () => {
    clear(root);
    for (const p of PROVIDERS) {
      const b = el('button', { role: 'tab', type: 'button', 'aria-selected': String(p === store.state.provider), text: PROVIDER_LABEL[p] });
      b.addEventListener('click', () => { store.set({ provider: p as Provider, selected: null }); location.hash = p; });
      root.append(b);
    }
  };
  render();
  store.subscribe((_s, changed) => { if (changed.has('provider')) render(); });
}
